"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateStepSuccess = exports.validateStepFailure = exports.copyProjectFailure = exports.copyProjectSuccess = exports.copyProjectRequest = exports.updateField = exports.fetchTemplatesFailed = exports.fetchTemplatesSuccess = exports.fetchTemplatesRequest = exports.searchCompanySuccess = exports.searchCompanyFailed = exports.searchCompanyRequest = exports.toggleCopyModal = void 0;
const ActionTypes = require("../../actionTypes/project/copy");
function toggleCopyModal(mode, project) {
    return {
        type: ActionTypes.TOGGLE_COPY_MODAL,
        payload: { mode, project }
    };
}
exports.toggleCopyModal = toggleCopyModal;
function searchCompanyRequest(companyName) {
    return {
        type: ActionTypes.SEARCH_COMPANY_REQUEST,
        payload: companyName
    };
}
exports.searchCompanyRequest = searchCompanyRequest;
function searchCompanyFailed(error) {
    return {
        type: ActionTypes.SEARCH_COMPANY_FAILED,
        payload: error
    };
}
exports.searchCompanyFailed = searchCompanyFailed;
function searchCompanySuccess(result) {
    return {
        type: ActionTypes.SEARCH_COMPANY_SUCCESS,
        payload: result
    };
}
exports.searchCompanySuccess = searchCompanySuccess;
function fetchTemplatesRequest() {
    return {
        type: ActionTypes.FETCH_TEMPLATES_REQUEST
    };
}
exports.fetchTemplatesRequest = fetchTemplatesRequest;
function fetchTemplatesSuccess(result) {
    return {
        type: ActionTypes.FETCH_TEMPLATES_SUCCESS,
        payload: result
    };
}
exports.fetchTemplatesSuccess = fetchTemplatesSuccess;
function fetchTemplatesFailed(error) {
    return {
        type: ActionTypes.FETCH_TEMPLATES_FAILED,
        payload: error
    };
}
exports.fetchTemplatesFailed = fetchTemplatesFailed;
const updateField = (key, value) => ({
    type: ActionTypes.UPDATE_FIELD,
    payload: {
        key,
        value
    }
});
exports.updateField = updateField;
function copyProjectRequest(params) {
    return {
        type: ActionTypes.COPY_PROJECT_REQUEST,
        payload: params
    };
}
exports.copyProjectRequest = copyProjectRequest;
function copyProjectSuccess(project) {
    return {
        type: ActionTypes.COPY_PROJECT_SUCCESS,
        payload: project
    };
}
exports.copyProjectSuccess = copyProjectSuccess;
function copyProjectFailure(error) {
    return {
        type: ActionTypes.COPY_PROJECT_FAILURE,
        payload: error
    };
}
exports.copyProjectFailure = copyProjectFailure;
const validateStepFailure = (errors) => ({
    type: ActionTypes.VALIDATE_STEP_FAILURE,
    payload: {
        errors
    }
});
exports.validateStepFailure = validateStepFailure;
const validateStepSuccess = () => ({
    type: ActionTypes.VALIDATE_STEP_SUCCESS
});
exports.validateStepSuccess = validateStepSuccess;
//# sourceMappingURL=copy.js.map